export const OPEN_CRM_SEARCH_EVENT = 'lctf-open-crm-search';
